import { Grid } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import React from 'react';
import { validationSchema } from './validation-schema';
import { useTranslation } from 'react-i18next';

type EmailActionFormProps = {
    initialValues: any;
    onSubmit: any;
    formRef: any;
};

export const RejectJobPostingForm: React.FC<EmailActionFormProps> = ({ initialValues, onSubmit, formRef }) => {
    const { t } = useTranslation();
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            innerRef={formRef}
        >
            {() => (
                <Form>
                    <Grid container style={{ marginBottom: '8px', marginTop: '8px' }} spacing={2}>
                        <Grid item xs={12}>
                            <Field
                                label={t('jobDetails:rejectReason')}
                                name="rejectReason"
                                component={TextField}
                                multiline
                                rows={10}
                                rowsMax={20}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};
